export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8000.f3572682.jpg";